<label
  [for]="question().name"
  class="block text-sm font-semibold text-slate-700 mb-2 tracking-tight"
>
  <span class="inf-question-name mr-2 text-blue-600">{{ question().name + " " }}</span>
  <hsuc-safe-script [scriptCode]="question().questionText"></hsuc-safe-script>
</label>
